var eventFilter = {};

(function (eventFilterApp) {
	var filterModel = {
		Category: "",
        Month: "",
        SearchTerm: "",
		Page: 1
	};
	var fromPopState = false;
	var blockPopstateEvent = true;
	var browserSupportsHistoryApi = window.history && 'pushState' in window.history;

	if (browserSupportsHistoryApi) {
		// prevent Chrome from calling onpopstate on initial load
		$(window).on('load', function () {
			// The timeout ensures that popstate-events will be unblocked right
			// after the load event occured, but not in the same event-loop cycle.
			setTimeout(function () { blockPopstateEvent = false; }, 0);
		});

		$(window).on('popstate', function () {
			if (blockPopstateEvent && document.readyState === "complete") {
				return;
			}
			fromPopState = true;
			performSearchFromUrl();
		});
	}

	function pushHistory() {
		if (browserSupportsHistoryApi && !fromPopState) {
			var currentPath = window.location.pathname;
			var query = "?";
			var queryArray = [];
			if (filterModel.Category) {
				queryArray.push("category=" + filterModel.Category);
			}
            if (filterModel.Month) {
				queryArray.push("month=" + filterModel.Month);
			}
            if (filterModel.SearchTerm) {
				queryArray.push("search=" + filterModel.SearchTerm);
			}
			if (filterModel.Page && filterModel.Page > 1) {
				queryArray.push("page=" + filterModel.Page);
			}
			query += queryArray.join("&");
			history.pushState(null, null, currentPath + query);
		}
		fromPopState = false;
	}

	function performSearchFromUrl() {
		filterModel.Category = "";
		filterModel.Month = "";
		filterModel.SearchTerm = "";
		filterModel.Page = 1;
		if (window.location.search.length > 1) {
			for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
				nKeyId < aCouples.length;
				nKeyId++) {
				aItKey = aCouples[nKeyId].split("=");
				if (aItKey.length <= 1)
					continue;
				var key = decodeURIComponent(aItKey[0]).toLowerCase();
				var val = decodeURIComponent(aItKey[1]);

				if (key === "category") {
					filterModel.Category = val;
				} else if (key === "month") {
					filterModel.Month = val;
				} else if (key === "search") {
					filterModel.SearchTerm = val;
				} else if (key === "page") {
					filterModel.Page = val;
				}
			}
		}
		eventFilter.SetFilters();
		eventFilter.GetFilterResult();
	}

	eventFilterApp.GetFilterResult = function () {
		$.ajax({
			url: "/umbraco/surface/EventSurface/GetFilterResult",
			type: "GET",
			data: filterModel,
			dataType: "html",
			success: function (data) {
				$(".js-event-filter-results").html(data);
				pushHistory(); 
            },
			error: function (xhr, status, error) {
				console.log(status);
				console.log(xhr.status + " - " + error);
			}
		});
	};

	eventFilter.SetFilters = function () {
		$('.js-category-filter').val(filterModel.Category);
		$('.js-when-filter').val(filterModel.Month);
		$('.js-search-term').val(filterModel.SearchTerm);
	};

	$(document).ready(function () {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.get('category'))
			filterModel.Category = urlParams.get('category');

		if (urlParams.get('month'))
			filterModel.Month = urlParams.get('month');

		if (urlParams.get('search'))
			filterModel.SearchTerm = urlParams.get('search');

		if (urlParams.get('page'))
			filterModel.Page = urlParams.get('page');

		$(document).on("submit", "#event-filter-form", function (e) {
			e.preventDefault();
			filterModel.Category = $('.js-category-filter').val();
			filterModel.Month = $('.js-when-filter').val();
			filterModel.SearchTerm = $('.js-search-term').val();
			filterModel.Page = 1;
			eventFilter.GetFilterResult();
		});

        $(document).on('click', 'ul.pagination a', function (e) {
			e.preventDefault();
            filterModel.Page = $(this).data('page');
			eventFilterApp.GetFilterResult();
			paginationScrollToTop();
		});

        function paginationScrollToTop() {
            $('html, body').animate({
				scrollTop: $(".js-event-filter-results").offset().top - $("header").outerHeight()
            }, 400);
        }
	});

})(eventFilter);
